module.exports = __webpack_public_path__ + "static/media/How to create File note Template.79f9309b.png";